import { Link, useHistory } from 'react-router-dom'
import { Container, Content, Empty, ExpandableList, List, SearchBar } from './styles'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useGetQuestionBooks } from '../../hooks/use-get-question-books'
import { TQuestionBook } from '../../../Questions/components/QuestionsContent/types'
import { BsSearch } from 'react-icons/bs'
import TextDropdown from '../../../../components/TextDropdown'
import { useEffect, useRef, useState } from 'react'
import { IoBookOutline } from 'react-icons/io5'
import Card from '../Card'

const options = [
  { label: 'Mais recentes', value: 'new' },
  { label: 'Mais antigos', value: 'old' },
]

const QuestionBooksContent = () => {
  const history = useHistory()

  const [isExpanded, setIsExpanded] = useState(false)
  const [fullHeight, setFullHeight] = useState(0)

  const expandableRef = useRef<HTMLDivElement | null>(null)

  const { swr, data, params } = useGetQuestionBooks()

  const isEmpty = swr.isLoading === false && data.length === 0

  const renderCard = (questionBook: TQuestionBook) => (
    <Card key={questionBook._id} data={questionBook} />
  )

  useEffect(() => {
    setFullHeight(expandableRef.current?.scrollHeight || 0)
  }, [data])

  return (
    <Container>
      <Content>
        <div className="divBeta">
          <h1 className="page-title">
            <button className="go-back" onClick={history.goBack}>
              <AiOutlineArrowLeft className="icon" />
            </button>
            Meus cadernos
          </h1>
        </div>

        <div className="inputs">
          <SearchBar>
            <BsSearch />

            <input
              type="text"
              placeholder="Buscar cadernos"
              onChange={(e) => params.setSearch(e.target.value)}
            />
          </SearchBar>

          <TextDropdown
            options={options}
            defaultValue="new"
            onChange={(value) => params.setOrder(value as 'new' | 'old')}
            disabled={data.length === 0}
            className="text-dropdown"
          />
        </div>

        <List>
          {swr.isLoading && (
            <>
              <div className="loading-block" />
              <div className="loading-block" />
              <div className="loading-block" />
              <div className="loading-block" />
            </>
          )}

          {data.slice(0, 4).map(renderCard)}
        </List>

        {data.length > 4 && (
          <>
            <ExpandableList
              ref={(node) => {
                expandableRef.current = node
                setFullHeight(node?.scrollHeight || 0)
              }}
              isExpanded={isExpanded}
              fullHeight={fullHeight}
            >
              {data.slice(4).map(renderCard)}
            </ExpandableList>

            <button
              type="button"
              className="see-more-button"
              onClick={() => setIsExpanded((state) => !state)}
            >
              Ver {isExpanded ? 'menos' : 'mais'}
            </button>
          </>
        )}

        {isEmpty && (
          <Empty>
            <IoBookOutline className="icon" />

            <p className="text">
              Você ainda não tem nenhum caderno criado. <br /> Faça uma pesquisa e crie agora mesmo.
            </p>

            <Link to="/questoes/buscar" className="link">
              Buscar questões
            </Link>
          </Empty>
        )}
      </Content>
    </Container>
  )
}

export default QuestionBooksContent
